import utils from '../utils/utils';
import serverApi from '../services/serverApi';
import {RT_EVENT_TYPE} from '../constants/rt-event-type';
import {CHAT_MESSAGE_TYPE, ACTIVITY_DIRECTION} from '../constants/chat-message-type';
import {PREVIEW_AUTO_RESPONSE} from '../constants/messages';
import {notifyTypingStatus} from '../reducers/message';

export const SEND_MESSAGE = 'SEND_MESSAGE';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_FAKE_MESSAGE = 'ADD_FAKE_MESSAGE';
export const COLLAPSE_CHAT = 'COLLAPSE_CHAT';
export const EXPAND_CHAT = 'EXPAND_CHAT';
export const REAL_TIME = 'REAL_TIME';
export const UPDATE_MESSAGE_VALUE = 'UPDATE_MESSAGE_VALUE';
export const TECHNICAL_ERROR = 'TECHNICAL_ERROR';
export const SHOW_CHAT = 'SHOW_CHAT';
export const HIDE_CHAT = 'HIDE_CHAT';
export const UPDATE_TEXTS = 'UPDATE_TEXTS';
export const UPDATE_LAYOUT = 'UPDATE_LAYOUT';
export const UPDATE_DESIGN = 'UPDATE_DESIGN';
export const CONNECTION_INFO_CHANGED = 'CONNECTION_INFO_CHANGED';

function createMessageMeta({message, clientReferenceId, customerToBusiness = true}) {
  clientReferenceId = clientReferenceId ? clientReferenceId : utils.createGuid();
  return {
    activity: {
      activityId: clientReferenceId,
      activityType: CHAT_MESSAGE_TYPE,
      dateTime: null,
      direction: customerToBusiness ? ACTIVITY_DIRECTION.CUSTOMER_TO_BUSINESS : ACTIVITY_DIRECTION.BUSINESS_TO_CUSTOMER,
      info: {
        activityInfo: {
          content: [{
            message
          }]
        }
      }
    },
    read: true,
    clientReferenceId,
    type: RT_EVENT_TYPE.ACTIVITY,
    contact: null,
    metaSiteId: ''
  };
}

function fakeMessage(action) {
  return (action.type === ADD_MESSAGE) ? Object.assign({}, action, {type: ADD_FAKE_MESSAGE}) : action;
}

function fulfillFakeMessage() {
  return {
    type: `${SEND_MESSAGE}_FULFILLED`,
    payload: {
      activityId: 'fake-message',
      dateTime: new Date()
    },
    meta: {
      clientReferenceId: 'fake-message'
    }
  };
}

export function autoResponseFlow(message) {
  return dispatch => {
    dispatch(addFakeMessage(message));
    setTimeout(() => {
      dispatch(fulfillFakeMessage());
      setTimeout(() => {
        dispatch(addFakeAutoResponse());
      }, 1000);
    }, 500);
  };
}

export function addFakeAutoResponse() {
  const msg = createMessageMeta({
    message: PREVIEW_AUTO_RESPONSE,
    clientReferenceId: 'fake-auto-response',
    customerToBusiness: false
  });
  msg.activity.dateTime = new Date();
  return fakeMessage(addMessage(msg));
}

function addFakeMessage(message) {
  return fakeMessage(addMessage(createMessageMeta({
    message,
    clientReferenceId: 'fake-message'
  })));
}

export function sendMessage(message) {
  const meta = createMessageMeta({message});
  return {
    type: SEND_MESSAGE,
    payload: serverApi.sendMessage(message, meta.clientReferenceId),
    meta
  };
}

export function resendMessage(message, clientReferenceId) {
  const meta = createMessageMeta({message, clientReferenceId});
  return {
    type: SEND_MESSAGE,
    payload: serverApi.sendMessage(message, meta.clientReferenceId),
    meta
  };
}

export function addMessage(message) {
  return {
    type: ADD_MESSAGE,
    meta: message
  };
}

export function updateMessageValueAndNotify(value) {
  return dispatch => {
    notifyTypingStatus(value);
    return dispatch(updateMessageValue(value));
  };
}

export function updateMessageValue(value) {
  return {
    type: UPDATE_MESSAGE_VALUE,
    value
  };
}

export function collapseChat() {
  return {
    type: COLLAPSE_CHAT
  };
}

export function technicalError(isError) {
  return {
    type: TECHNICAL_ERROR,
    isError
  };
}

export function realTime(status) {
  return {
    type: REAL_TIME,
    status
  };
}

export function expandChat(initiator) {
  return {
    type: EXPAND_CHAT,
    initiator
  };
}

export function showChat() {
  return {
    type: SHOW_CHAT
  };
}

export function hideChat() {
  return {
    type: HIDE_CHAT
  };
}

export function updateTexts(texts) {
  return {
    type: UPDATE_TEXTS,
    texts
  };
}

export function updateDesign(design) {
  return {
    type: UPDATE_DESIGN,
    design
  };
}

export function updateLayout(layout) {
  return {
    type: UPDATE_LAYOUT,
    layout
  };
}

export function connectionInfoChanged(connectionInfo) {
  return {
    type: CONNECTION_INFO_CHANGED,
    connectionInfo
  };
}



// WEBPACK FOOTER //
// ./chat-app/actions/index.js